import { ParceirosPremioCard } from '@/pages/parceiros/ParceirosPremioCard'
import { ParceirosStatusBadge } from '@/pages/parceiros/ParceirosStatusBadge'
import { formatCurrency } from '@/utils/format-currency'
import type { PartnerView } from '@/components/Partners/partnerView.types'

export function PartnerDetailIndicacoesTab({ partner }: { partner: PartnerView }) {
  const rows = partner.indicacoes ?? []

  return (
    <div className='space-y-5'>
      <ParceirosPremioCard rows={rows} loading={false} />

      <div className='glass-card p-0 overflow-hidden'>
        <div className='overflow-x-auto'>
          <table className='w-full'>
            <thead>
              <tr className='border-b border-[var(--glass-border)]'>
                {['Cliente', 'Contato', 'Origem', 'Status', 'Contrato'].map((header) => (
                  <th
                    key={header}
                    className='px-4 py-3 text-left text-[var(--font-color-label)] font-medium uppercase tracking-wider'
                    style={{ fontSize: 'var(--font-size-label)' }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className='px-4 py-8 text-center text-sm text-[var(--font-color-muted)]'>
                    Nenhuma indicação ou cadastro deste parceiro ainda.
                  </td>
                </tr>
              ) : (
                rows.map((row) => (
                  <tr key={`${row.origem}-${row.id}`} className='border-b border-[var(--glass-border)] last:border-0'>
                    <td className='px-4 py-3'>
                      <p className='text-sm font-medium text-[var(--font-color-body)]'>{row.empresa}</p>
                      <p className='text-[11px] text-[var(--font-color-muted)]'>{row.nome || 'Sem nome'}</p>
                    </td>
                    <td className='px-4 py-3 text-[11px] text-[var(--font-color-body)]'>
                      <p>{row.email || '—'}</p>
                      <p className='text-[var(--font-color-muted)]'>{row.telefone || '—'}</p>
                    </td>
                    <td className='px-4 py-3 text-[11px] uppercase tracking-wide text-[var(--font-color-muted)]'>{row.origem}</td>
                    <td className='px-4 py-3'>
                      <ParceirosStatusBadge status={row.publicStatus} />
                    </td>
                    <td className='px-4 py-3 text-sm font-semibold text-[var(--font-color-body)]'>
                      {row.contratoMensal ? formatCurrency(row.contratoMensal) : '—'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
